// Node imports
import { ButtonBase, dispatcher, ingenuity } from "@quest/base-core";
import { ButtonController, Model, SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SlotConstants, SlotEventConstants } from "@quest/slot-core";
import { GameParserModel } from "../Platform/GameParserModel";
import { BaseGameViewGame } from "./BaseGameViewGame";
import { gameConstants } from "../Constants/gameConstants";

/**
 * ButtonControllerGame class handles the  console panelo of the base game and its buttons.
 */
export class ButtonControllerGame extends ButtonController {
  constructor(view: BaseGameViewGame, model: Model) {
    super(view, model);
    this.handleButtonPanelBGAlpha();
  }

  /**
   * temporarily created as image does not have alpha support from json
   * add alpha support in Basegameview to avoid this implementation
   */
  private handleButtonPanelBGAlpha(): void {
    this.view.getImageById("Button_Panel_Base") &&
      (this.view.getImageById("Button_Panel_Base").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA);
    this.view.getImageById("portraitButtonBG") &&
      (this.view.getImageById("portraitButtonBG").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA);
    this.view.getImageById("Button_Panel_BasePort") &&
      (this.view.getImageById("Button_Panel_BasePort").alpha = gameConstants.BUTTON_PANEL_BG_ALPHA);
  }
  /**
   * to handle reel swaping from left to right
   */
  protected onBetMinusPressUp(): void {
    super.onBetMinusPressUp();
    dispatcher.fireEvent(eventDispatchers.SHIFT_REEL_TO_RIGHT);
  }
  /**
   * to handle reel swaping from right to left
   */
  protected onBetPlusPressUp(): void {
    super.onBetPlusPressUp();
    dispatcher.fireEvent(eventDispatchers.SHIFT_REEL_TO_LEFT);
  }
  /**
   * to handle feature on bet change
   */
  protected onChangeStake(value: number): void {
    super.onChangeStake(value);
    dispatcher.fireEvent(eventDispatchers.HANDLE_FEATURE_ON_BET_CHANGE);
    (ingenuity.parserModel as GameParserModel).setCommonOffsetsOfStackAndWin([]);
  }
  /**
   * to suspend presentation on pressup
   */
  protected onturboBtnOnPressUp(): void {
    super.onturboBtnOnPressUp();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  protected onturboBtnOffPressUp(): void {
    super.onturboBtnOffPressUp();
    this.suspendWinWhenButtonPressed();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  /**
   * to suspend presentation on pressup
   */
  protected onInfoPressUp(): void {
    super.onInfoPressUp();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  /**
   * to suspend presentation on pressup
   */
  protected onSettingPressUp(): void {
    super.onSettingPressUp();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  /**
   * to suspend presentation on pressup
   */
  protected onAutoPlayPressUp(): void {
    super.onAutoPlayPressUp();
    dispatcher.fireEvent(SlotEventConstants.SUSPEND_WINPRESENTATION);
  }
  /**
   * to hide player msg
   */
  protected onSpinPressUp(button?: ButtonBase): void {
    super.onSpinPressUp(button);
    dispatcher.fireEvent(eventDispatchers.HIDE_BET_CHANGE_MSG);
  }
  // Override to hide autoplaybtn in mobile and desktop both
  protected hideAutoplayOnBtn() {
    this.view.getButtonById(SlotConstants.AutoPlayBtnId).visible = false;
  }


  protected onDisabledAllButtons(evt: any) {
    let btnId;
    for (btnId in this.view.getbuttonArray()) {
      if (SlotConstantsBehavior.SOUND_BUTTONS.indexOf(btnId) === -1) {
        if (btnId != "autoPlayOff") {
          (this.view.getbuttonArray()[btnId] as ButtonBase).disableAndTint();
        }
      }
    }
    if (this.turboBtnOn.visible) {
      this.turboBtnOn.disableAndTint();
    } else {
      this.turboBtnOff.disableAndTint();
    }
  }
}
